// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__2DdWG","content":"LoadingAlert_content__20K46"};